export function setCookie(name, value, days) {
	let expires = '';

	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}

	document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
}

export function getCookie(name) {
	const match = document.cookie
		.split('; ')
		.find(row => row.indexOf(name + '=') === 0);

	return match ? decodeURIComponent(match.split('=')[1]) : null;
}
